import React from "react";

export const useRecoveryPassword = () => {
  function handleSubmitForm(data: any) {
    throw new Error("Deve ser implementado");
  }

  return { handleSubmitForm };
};
